import * as angular from "angular";
import {DescriptionFilter} from "./description.filter";
import {ReferenceData} from "./reference-data.service";

export const ReferenceDataModule = angular
    .module("app.shared.referenceData", [])

    .filter("description", DescriptionFilter)

    .service("referenceData", ReferenceData)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/reference-data/reference-data.module.ts